export function generateUUID(): string {
  if (typeof crypto?.randomUUID === 'function') {
    return crypto.randomUUID();
  }

  // Fallback (RFC4122 version 4 UUID)
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (c) => {
    const r = (Math.random() * 16) | 0;
    const v = c === 'x' ? r : (r & 0x3) | 0x8;
    return v.toString(16);
  });
}

export function getOrCreateAnonId(): string {
  let id = localStorage.getItem('anon_user_id');
  if (!id) {
    id = `anon-${generateUUID()}`;
    localStorage.setItem('anon_user_id', id);
  }
  return id;
}
